import { render, staticRenderFns } from "./resources-data-save.vue?vue&type=template&id=0057bef2&scoped=true&"
import script from "./resources-data-save.vue?vue&type=script&lang=js&"
export * from "./resources-data-save.vue?vue&type=script&lang=js&"
import style0 from "./resources-data-save.vue?vue&type=style&index=0&id=0057bef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057bef2",
  null
  
)

export default component.exports